import React, { useEffect, useState } from "react";
import Card from "components/common/Card";
import { Msg } from "./components/Msg";
import { OurAdvice } from "./components/OurAdvice";
import { Disclaimer } from "./components/Disclaimer";
import ButtonOutline from "components/semantic/ButtonOutline";
import Button from "components/semantic/Button";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getMotorKypResult, getSinglePolicy } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import ResultHeading from "./components/Heading";
import MailCopyModal from "./components/MailCopyModal";
import PaymentCard from "pages/benefitSummary/components/PaymentCard";
import { BlurScreenResult } from "./components/blurScreenResult";
import PolicySkeletonCard from "./components/SkeletonCard";
import { HeadingSmallScreen } from "./components/headingSmallScreen";
import { onGmailShare } from "utils/utils";
import { MotorRecommendation } from "./components/motorRecommendation";
import MotorPolicyAction from "./components/MotorPolicyAction";

const MotorResult: React.FC = () => {
  const param: any = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [showCopyModal, setShowCopyModal] = useState(false);

  const motorResultData = useAppSelector((state) => state.rootReducer.kypSlice.motorResultData);
  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.policyData);

  useEffect(() => {
    dispatch(getSinglePolicy(param?.policyId));
    dispatch(getMotorKypResult(param?.policyId));
  }, [dispatch, param]);
  const goToHomeHandler = () => {
    navigate("/kyp/policies");
  };

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-2xl font-extrabold mb-6">Know Your Policy</h1>
      {/* While res getting skeleton */}
      {!policyData || !motorResultData ? (
        <PolicySkeletonCard />
      ) : (
        <>
          {!["PAID", "WAIVEOFF"].includes(policyData.kypPaymentStatus) ? (
            <>
              <BlurScreenResult type={motorResultData.ResultTitle} />
              <PaymentCard feeAmount={policyData.kypFeeAmount} />
            </>
          ) : (
            <Card className="rounded-xl md:shadow-sm shadow-none overflow-hidden" parentClassName=" !shadow-none md:shadow-xl border-none md:border-[1px]" bg="bg-none md:bg-white">
              <ResultHeading resultData={motorResultData} />
              {motorResultData.ResultTitle && <Msg policyData={motorResultData} />}
              <div className="md:hidden sm:px-6">
                <HeadingSmallScreen onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(motorResultData)} policyData={motorResultData} policyType={policyData.policyTypeId} fromHospital={false} policyTypeId={false} />
              </div>
              <div className="sm:px-6 mx-0 md:mx-6">
                {motorResultData.ResultTitle !== "Healthy" && <OurAdvice onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(motorResultData)} policyData={motorResultData} />}
                {motorResultData.ResultTitle && <MotorPolicyAction type={motorResultData.ResultTitle} onDownload={() => window.open(motorResultData.pdfUrl)} onCopy={() => setShowCopyModal(true)} onGmailShare={() => onGmailShare(motorResultData)} />}
                <MotorRecommendation />
                {motorResultData.ResultTitle !== "Healthy" && <Disclaimer bg={true} />}
              </div>
              <div className="flex gap-1 md:gap-4 justify-center items-center py-5 px-2 w-full md:px-5 border-t md:rounded-none rounded-xl bg-white">
                <ButtonOutline title="Go To Home" onClick={goToHomeHandler} className="w-full border-gray-300" />
                <Button title="Check Another Policy" onClick={() => navigate("/kyp/upload-policy")} className="w-full mx-1 text-sm md:text-base" />
              </div>
            </Card>
          )}
          <MailCopyModal isOpen={showCopyModal} onClose={() => setShowCopyModal(!showCopyModal)} mailDetails={motorResultData?.Draft} />
        </>
      )}
    </div>
  );
};

export default MotorResult;
